import React, { useEffect, useState } from "react";
import { customerListId, addToCard } from "../../../server/ShoppingList";
import { useParams } from "react-router-dom";
import showAlert from "../../../server/ShowAlert";
import { getCart } from "../../../server/CollectSite";
import { addProductToList } from "../../../server/ShoppingList";
import { setPreload } from "../../../server/CartsOpen";
import { useDispatch, useSelector } from "react-redux";
import { set } from "react-hook-form";

const UserShoppingListProduct = ({ setProductPopUp, setSelectedProd }) => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const stationId = useSelector((state) => state.user.stationId);
  const [products, setProducts] = useState(null);
  const [listName, setListName] = useState("טוען רשימה...");
  const [listId, setListId] = useState("");

  useEffect(() => {
    getProductList();
  }, []);
  const getProductList = () => {
    customerListId(id)
      .then((x) => {
        if (x.data) {
          setListId(x.data.Id);
          setListName(x.data.Name);
          if (x.data.customer_list_product) {
            setProducts(x.data.customer_list_product);
          }
        }
      })
      .catch((e) => {
        if (e.response.status === 404) {
          setListName("הרשימה לא נמצאה");
          showAlert({ msgTitle: "הרשימה לא נמצאה", msgType: "error" });
        }
        console.log(e);
      });
  };
  const AddToCard = () => {
    addToCard(id, stationId)
      .then((x) => {
        if (x.data) {
          dispatch(getCart());
          showAlert({
            msgTitle: "הרשימה התווספה לעגלת קניות",
            msgType: "success",
          });
        } else {
          showAlert({
            msgTitle: "הייתה בעיה בהוספת הרשימה לעגלת קניות",
            msgType: "error",
          });
        }
      })
      .catch(() => showAlert());
  };
  const SetQuantity = (value, id) => {
    const product = [...products];
    product.find((item) => item.Id === id).Quantity = value;
    setProducts(product);
  };
  const AddToShopList = (quantity, mkt) => {
    dispatch(setPreload(true));
    const val = {
      Quantity: quantity,
      ProductMkt: mkt,
      CustomerListId: listId,
    };
    addProductToList(val)
      .then((x) => {
        if (x.data) {
          showAlert({ msgTitle: "הכמות השתנה", msgType: "success" });
        } else {
          const product = [...products];
          product.splice(
            product.findIndex((item) => item.Id === id),
            1,
          );
          setProducts(product);
          showAlert({ msgTitle: "המוצר נמחק מהרשימה ", msgType: "error" });
        }
        if (quantity === 0) {
          setProducts(products.filter((item) => item.Mkt !== mkt));
        }
      })
      .catch(() => showAlert())
      .finally(() => dispatch(setPreload(false)));
  };

  const openProduct = (prod) => {
    console.log(prod);
    setSelectedProd(prod);
    setProductPopUp(true);
  };

  return (
    <div className="shopping-list-product">
      {listName ? (
        <div>
          <h1>{listName}</h1>
          {products?.length > 0 ? (
            <div>
              <table>
                <tbody>
                  <tr>
                    <th>שם המוצר</th>
                    <th>כמות</th>
                    <th></th>
                    <th></th>
                  </tr>
                  {products.map((prod) => (
                    <tr key={prod.Id}>
                      <td>
                        <a
                          style={{ cursor: "pointer" }}
                          onClick={() => openProduct(prod)}
                        >
                          {prod.ProductName}
                        </a>
                      </td>
                      <td>
                        {" "}
                        <input
                          type="number"
                          value={prod.Quantity}
                          onChange={(e) => SetQuantity(e.target.value, prod.Id)}
                          onBlur={(e) => SetQuantity(e.target.value, prod.Id)}
                        />
                      </td>
                      <td>
                        <button
                          className="btn"
                          onClick={() =>
                            AddToShopList(parseInt(prod.Quantity), prod.Mkt)
                          }
                        >
                          שמור
                        </button>
                      </td>
                      <td>
                        <button
                          className="btn"
                          onClick={() => AddToShopList(0, prod.Mkt)}
                        >
                          מחק מוצר
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div>
                <button className="btn" onClick={AddToCard}>
                  הוספה לסל קניות
                </button>
              </div>
            </div>
          ) : (
            products && <h2>אין פריטים ברשימה</h2>
          )}
        </div>
      ) : (
        <h1>אין רשימה להצגה</h1>
      )}
    </div>
  );
};

export default UserShoppingListProduct;
